import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class ScoreDial extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, roundNumber)
    {
        super(scene);

        this.roundNumber = roundNumber;

        ABCyaPhaser.Images.addImage(0, 106, UIAssetKeys._round_dial, this);

        this.textLabel1 = ABCyaPhaser.Text.addText(-7, 85, 34, 0xffffff, FontKeys._odin_roundedregular, this.roundNumber, this).setOrigin(0);

        if (this.roundNumber > 0)
        {
            let dot = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._green_dot, this);
            dot.x = -99 +18;
            dot.y = 101 +2;
        }

        if (this.roundNumber > 1)
        {
            let dot = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._green_dot, this);
            dot.x = -99 + 20+13;
            dot.y = 101 + +17+2-1;
        }

        if (this.roundNumber > 2)
        {
            let dot = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._green_dot, this);
            dot.x = -99 + 41 + 10;
            dot.y = 101 + 30;
        }

        if (this.roundNumber > 3)
        {
            let dot = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._green_dot, this);
            dot.x = -99 + 65 + 4;
            dot.y = 101 + 37 - 2;
        }

        if (this.roundNumber > 4)
        {
            let dot = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._green_dot, this);
            dot.x = -99 + 90;
            dot.y = 101 + +40;
        }

        if(this.roundNumber > 5) {

            let dot = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._green_dot, this);
            dot.x = -99 + 115 - 7;
            dot.y = 101 + 40;
        }

        if(this.roundNumber > 6) {

            let dot = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._green_dot, this);
            dot.x = -99 + 139 - 10;
            dot.y = 101 + 35;
        }

        if(this.roundNumber > 7) {

            let dot = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._green_dot, this);
            dot.x = -99 + 162 - 14;
            dot.y = 101 + 26 + 2;
        }

        if(this.roundNumber > 8) {

            let dot = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._green_dot, this);
            dot.x = -99 + 184 - 18;
            dot.y = 101 + 13 + 2;
        }

        if(this.roundNumber > 9) {

            let dot = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._green_dot, this);
            dot.x = -99 + 203 - 22
            dot.y = 101 - 0;
        }

        if(this.roundNumber == 1) {

            let dot = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._green_dot_selected, this);
            dot.x = -99 + 18;
            dot.y = 101 + 2;
        }

        if(this.roundNumber == 2) {

            let dot = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._green_dot_selected, this);
            dot.x = -99 + 20 + 13;
            dot.y = 101 + 17 + 2 - 1;
        }

        if(this.roundNumber == 3) {

            let dot = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._green_dot_selected, this);
            dot.x = -99 + 41 + 10;
            dot.y = 101 + 30;
        }

        if(this.roundNumber == 4) {

            let dot = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._green_dot_selected, this);
            dot.x = -99 + 65 + 4;
            dot.y = 101 + 37 - 2;
        }

        if(this.roundNumber == 5) {

            let dot = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._green_dot_selected, this);
            dot.x = -99 + 90;
            dot.y = 101 + 40;
        }

        if(this.roundNumber  == 6) {

            let dot = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._green_dot_selected, this);
            dot.x = -99 + 115 - 7;
            dot.y = 101 + 40;
        }

        if(this.roundNumber == 7) {

            let dot = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._green_dot_selected, this);
            dot.x = -99 + 139 - 10;
            dot.y = 101 + 35;
        }

        if(this.roundNumber == 8) {

            let dot = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._green_dot_selected, this);
            dot.x = -99 + 162 - 14;
            dot.y = 101 + 26 + 2;
        }

        if(this.roundNumber == 9) {

            let dot = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._green_dot_selected, this);
            dot.x = -99 + 184 - 18;
            dot.y = 101 + 13 + 2;
        }

        if(this.roundNumber  == 10) {

            let dot = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._green_dot_selected, this);
            dot.x = -99 + 203 - 22
            dot.y = 101 - 0;
        }
    }
}